import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import InAppMessage from "./models/in-app-message.js";
import je from "./in-app-message-manager-factory.js";
import { IamStrings as sr } from "./constants.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
export function logInAppMessageImpression(s) {
  if (!r.rr()) return !1;
  if (!(s instanceof InAppMessage || s instanceof ControlMessage))
    return E.error(sr.sS), !1;
  const o = s instanceof ControlMessage ? f.om : f.wn;
  return je.ra().lt(s, o).W;
}
